import React from "react";
function FmcgProducts() {
  return <h1>FmcgProducts page</h1>;
}

export default FmcgProducts;
